<div id="mainModal" class="create-edit-modal">
  <div class="modal-header">
    <h2 class="modal-title">
      {{
        (productEntities$ | async)[serieProposalItem?.linkedProductId]
          ?.description
      }}
      -
      {{
        serieProposalItem?.startDate
          | date : 'EE dd MMM yyyy' : null : (selectedLanguage$ | async)
      }}
    </h2>
    <button
      type="button"
      class="btn-close"
      attr.aria-label="{{ 'general.close' | translate }}"
      (click)="cancel()"
    ></button>
  </div>

  <div class="modal-body">
    <div *ngIf="intersectingBookings?.length">
      <h3>{{ 'serieProposalModule.intersectingBookings' | translate }}:</h3>

      <booking-table
        [tableData]="intersectingBookings"
        [showStatus]="false"
        [showPageFooter]="false"
        [showTotal]="false"
        (onClickRow)="onClickRow($event)"
      ></booking-table>
    </div>

    <div class="row mb-4">
      <!-- member -->
      <div class="col-4">
        <label class="form-label">
          {{ 'memberModule.member' | translate }}
        </label>
        <p>{{ member.firstName }} {{ member.lastName }}</p>
      </div>

      <!-- location -->
      <div class="col">
        <label class="form-label">
          {{ 'general.location' | translate }}
        </label>
        <p>{{
          (locationEntities$ | async)[
            (productEntities$ | async)[serieProposalItem.productId]?.locationId
          ]?.description
        }}</p>
      </div>
    </div>

    <form
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      #formRef="ngForm"
      [patchForm]="serieProposalItem"
    >
      <fieldset class="mb-4">
        <legend class="form-label">
          {{ 'general.date' | translate }}
        </legend>

        <div class="d-flex align-items-center">
          <datetime-input
            [hideTime]="true"
            formControlName="startDate"
          ></datetime-input>

          <time-input formControlName="startTime"></time-input>

          <span class="bold ms-2"> - </span>

          <time-input formControlName="endTime" class="ms-2"></time-input>
        </div>
      </fieldset>

      <div class="mb-4">
        <fieldset>
          <legend class="inline-form-label">
            {{ 'general.sendEmailNotification' | translate }}
          </legend>
          <dms-switch
            [filterStyle]="false"
            [textItem1]="'general.yes'"
            [textItem2]="'general.no'"
            [responseItem1]="false"
            [responseItem2]="true"
            (onEmitItem1)="form.controls['dontSendMail'].patchValue($event)"
            (onEmitItem2)="form.controls['dontSendMail'].patchValue($event)"
            attr.aria-label="{{ 'general.sendEmailNotification' | translate }}"
          >
          </dms-switch>
        </fieldset>
      </div>

      <div
        class="spinner-border"
        role="status"
        attr.aria-label="{{ 'general.loading' | translate }}"
        *ngIf="isLoading$ | async"
      >
      </div>

      <div
        *ngIf="!(isLoading$ | async)"
        class="d-flex mt-3"
        [ngClass]="{
          'justify-content-between':
            serieProposalItem?.id &&
            !(
              serieProposalItem?.status == serieProposalItemStatus.DECLINED ||
              serieProposalItem?.status == serieProposalItemStatus.ACCEPTED
            ),
          'justify-content-end':
            !serieProposalItem?.id ||
            serieProposalItem?.status == serieProposalItemStatus.DECLINED ||
            serieProposalItem?.status == serieProposalItemStatus.ACCEPTED
        }"
      >
        <button
          [canSee]="[accessRights.SerieProposal_delete]"
          class="btn btn-warning"
          [hidden]="
            !serieProposalItem?.id ||
            serieProposalItem?.status == serieProposalItemStatus.DECLINED
          "
          type="button"
          (click)="onClickDeclineProposalItem()"
        >
          {{ 'serieProposalModule.decline' | translate }}
        </button>
        <button
          [canSee]="[accessRights.SerieProposal_write]"
          class="btn btn-primary"
          type="button"
          [disabled]="!showSendCounterProposal()"
          (click)="onClickSendCounterProposal()"
        >
          {{ 'serieProposalModule.updateAndSendCounterProposal' | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
